module.exports = __webpack_public_path__ + "static/media/M114ws.45282355.pdf";